<template>
  <div class="success-page min-h-screen flex flex-col items-center justify-start pt-16">
    <div class="bg-white p-8 rounded-lg shadow-lg text-center max-w-lg">
      <!-- Confetti Effect -->
      <div class="confetti"></div>

      <!-- Success Message -->
      <h1 class="text-4xl font-bold text-green-600 mb-4">Payment Successful!</h1>
      <p class="text-lg text-gray-700 mb-6">Thank you for your payment. Your transaction has been successfully completed!</p>

      <!-- Festive Image (Optional) -->
      <!-- <img src="https://cdn.pixabay.com/photo/2017/02/01/13/52/celebration-2022027_960_720.png" alt="Celebration" class="mx-auto mb-6 w-40 h-40"/> -->

      <!-- Continue Button -->
      <button
          @click="goToProfile"
          class="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg text-lg">
        Continue to Profile
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToProfile () {
      // Redirect user to the profile page
      this.$router.push('/profile')
    }
  }
}
</script>

<style scoped>
/* Simple confetti effect */
.confetti {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*background: radial-gradient(circle, rgba(255,255,255,0) 60%, rgba(255,204,0,0.5) 61%, rgba(0,204,255,0.3) 62%, rgba(255,102,255,0.7) 63%);*/
  /*animation: confetti 4s infinite linear;*/
  z-index: -1;
}

@keyframes confetti {
  0% { background-position: 0 0; }
  100% { background-position: 100% 100%; }
}
</style>
